// TODO: rewrite code without try/catch
/* eslint no-empty: 0 */
import _ from 'underscore';
import $ from 'jquery';
import { Model } from 'backbone';
import URI from 'urijs';

import store from 'wgnet-awesomejs/lib/store';

const STORAGE = Symbol('storage');
const DYNAMIC = Symbol('dynamic');

const SettingsModel = Model.extend({
    initialize(attrs = {}, options = {}) {
        this.appName = options.appName || 'wgn';
        this.set({
            urls: {
                SettingsUrl: window.SETTINGS_API_URL || this.get('SETTINGS_API_URL'),
                AccountStateUrl: window.ACCOUNT_STATE_API_URL || this.get('ACCOUNT_STATE_API_URL')
            }
        });

        this[STORAGE] = `${this.appName}_settings`;
        const storedAttr = this.getStoreSettings();
        const initSettings = {};

        $.extend(true, initSettings, attrs, storedAttr);
        Model.prototype.initialize.call(this, attrs, options);
        this.set(initSettings);
        if (this.get('LEAD_SYNC')) {
            this.startSync();
        }
    },
    getStoreSettings() {
        try {
            return JSON.parse(unescape(store.get(this[STORAGE])));
        } catch (e) {
            return {};
        }
    },
    onUpdate() {
        return new Promise((resolve) => {
            if (this.updated) {
                resolve();
            } else {
                this.once('update', () => {
                    resolve();
                });
            }
        });
    },
    startSync(silent = false) {
        this.updated = false;
        return Promise.all([
            this.syncBaseSettings(),
            this.syncAccountState(),
            Promise.resolve(silent)
        ]).then(this.settingsFetchSuccess.bind(this));
    },
    syncBaseSettings() {
        const settingsUrl = this.get('urls.SettingsUrl');

        return new Promise((resolve) => {
            this.fetch({
                method: 'GET',
                url: settingsUrl
            }).then(resolve).catch(() => {
                resolve({});
            });
        });
    },
    syncAccountState() {
        const query = URI.parseQuery(window.location.search);
        const accountStateURI = new URI(this.get('urls.AccountStateUrl'));
        const passThroughParameters = window.STATE_PASS_THROUGH_PARAMETERS || [];

        const passThroughQuery = _.pick(query, passThroughParameters);

        accountStateURI.setQuery(passThroughQuery);

        return new Promise((resolve) => {
            this.fetch({
                method: 'GET',
                url: accountStateURI.toString()
            }).then(resolve).catch(() => {
                resolve({});
            });
        });
    },
    settingsFetchSuccess([settingsResult, stateResult, silent]) {
        this[DYNAMIC] = stateResult;
        const storeSettings = escape(JSON.stringify(settingsResult));
        try {
            store.set(this[STORAGE], storeSettings);
        } catch (e) {
            console.log('Can not store settings in private mode.');
        }
        this.set(settingsResult);
        this.set(stateResult);
        this.updated = true;
        if (!silent) {
            this.trigger('update');
        }
    },
    extract(context, key) {
        const k = key.shift();

        const property = context[k];
        if (_.isUndefined(property) || key.length === 0) {
            return property;
        }
        return this.extract(property, key);
    },
    get(key, def) {
        if (_.isString(key) && key.length > 0) {
            const keys = key.split('.');
            const value = this.extract(this.attributes, keys);
            return value || def;
        }
        return this.attributes;
    },
    set(attrs) {
        $.extend(true, this.attributes, attrs);
    }
});

export default SettingsModel;



// WEBPACK FOOTER //
// ./static-source/js/lib/base_settings_model.js